import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { NotificationType } from '@atlassian/notification-types/types';
import messages from '../../../common/utils/i18n/messages';
import { AvatarWrapper, ExpandButton, ExpandGroupButtonWrapper } from './styled';
import { ExpandedState } from './types';
import AsyncAvatarGroup from './utils';
var notificationTypeToFormattedTextMap = new Map([[NotificationType.COMMENT, messages.notificationGroupExpandComment], [NotificationType.MENTION, messages.notificationGroupExpandMention], [NotificationType.ASSIGN, messages.notificationGroupExpandAssigneeChanged], [NotificationType.TRANSITION, messages.notificationGroupExpandIssueTransitioned], [NotificationType.TASK, messages.notificationGroupExpandTaskAssigned], [NotificationType.SHARE, messages.notificationGroupExpandPageShared], [NotificationType.OTHER, messages.notificationGroupExpandOther]]);
var ExpandGroupButton = function ExpandGroupButton(_ref) {
  var state = _ref.state,
    onClick = _ref.onClick,
    _ref$actors = _ref.actors,
    actors = _ref$actors === void 0 ? [] : _ref$actors,
    notificationTypes = _ref.notificationTypes,
    notificationCount = _ref.notificationCount;
  var formattedMessage;
  switch (state) {
    case ExpandedState.Complete:
      formattedMessage = messages.notificationGroupCollapse;
      break;
    case ExpandedState.Open:
      formattedMessage = messages.notificationGroupExpandMore;
      break;
    case ExpandedState.Collapsed:
      formattedMessage = (notificationTypes === null || notificationTypes === void 0 ? void 0 : notificationTypes.length) === 1 && notificationTypeToFormattedTextMap.get(notificationTypes[0]) || messages.notificationGroupExpandOther;
      break;
    default:
      formattedMessage = messages.notificationGroupExpandOther;
  }
  return /*#__PURE__*/React.createElement(ExpandGroupButtonWrapper, null, state === ExpandedState.Collapsed && actors.length > 0 && /*#__PURE__*/React.createElement(AvatarWrapper, {
    "data-testid": "avatar-wrapper"
  }, /*#__PURE__*/React.createElement(AsyncAvatarGroup, {
    appearance: "stack",
    size: "small",
    data: actors.map(function (actor) {
      return {
        src: actor.avatarUrl,
        name: actor.displayName || ''
      };
    })
  })), /*#__PURE__*/React.createElement(ExpandButton, {
    role: "button",
    testId: "notification-group-expand-button",
    appearance: "link",
    spacing: "none",
    onClick: onClick
  }, state === ExpandedState.Collapsed ? /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, formattedMessage, {
    values: {
      notificationCount: notificationCount,
      singleAuthor: actors.length,
      author: actors.length > 0 && actors[0].displayName
    }
  })) : /*#__PURE__*/React.createElement(FormattedMessage, formattedMessage)));
};
export default ExpandGroupButton;